import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { schema } from "./schema";
import { useContext } from "react";
import { ContextRegisterClient } from "../context";
import Notification from "../../../toast";
import reqCliente from "../../../../services/reqMultiTenant/reqCliente";

export const IndexHooks = () => {
	const { setClientsData, setFilterData, openModalFilterClient, currentPage, setPage, setTotalPage, setLoading } =
		useContext(ContextRegisterClient);
	const {
		handleSubmit,
		register,
		watch,
		setFocus,
		formState: { errors, isSubmitting },
		control,
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			param: "nome",
			paramValue: "",
			active: true,
		},
	});

	const paramSelected = watch("param");

	const handleOnSubmit = async (data) => {
		await fetchClients(data);
	};

	const fetchClients = async (filterDataSelected) => {
		try {
			setLoading(true);
			const { param, paramValue, active } = filterDataSelected;

			let ativo = "NAO";
			if (active === true) ativo = "SIM";

			const responseClient = await reqCliente.listPaginate(param, paramValue, ativo, 1);
			const recordCount = responseClient.data.length;

			// setClientsData((prevData) => [...prevData, ...responseClient.data]);
			setClientsData(responseClient.data);

			//se não encontrou nada esta na ultima pagina
			if (responseClient.data.length < 15) {
				setTotalPage(1);
			} else {
				setTotalPage(0);
				currentPage.current = 1;
			}

			const filter = { ...filterDataSelected, ativo, recordCount };

			setFilterData(filter);
			setPage(1);

			closeModal();
		} catch (error) {
			setClientsData([]);
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	const closeModal = () => {
		openModalFilterClient((prevState) => !prevState);
	};

	return {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		control,
		Controller,
	};
};
